<template>
	<BottomSheet
		title="Cart"
		v-model="openCart"
		:close-icon="'chevron'"
		:show-cart-icon="false"
		:loading="loading"
	>
		<TransitionGroup tag="ul" name="list" class="cart">
			<li class="cart__item-wrapper" v-for="item in cart" :key="item.id">
				<div class="cart__item">
					<div class="cart__item-image flex-center">
						<img :src="item.image" />
					</div>
					<div class="cart__item-content">
						<h5 class="cart__item-title">{{ item.name }}</h5>
						<p class="cart__item-price">
							<span
								>{{ item.price.toLocaleString("en-US") }} {{ currency }}</span
							>
						</p>
						<div class="cart__quantiy flex-center">
							<button
								:disabled="loading"
								class="btn-icon btn-minus cart__btn-quantity"
								@click="
									if (item.quantity - 1 >= 1)
										updateCart(item.id, item.quantity - 1, true);
								"
							></button>
							<span>{{ item.quantity }}</span>
							<button
								:disabled="loading"
								class="btn-icon btn-plus cart__btn-quantity"
								@click="updateCart(item.id, item.quantity + 1)"
							></button>
						</div>
					</div>
					<div class="cart__item-action">
						<button
							:disabled="loading"
							class="btn-icon cart__btn-delete"
							@click="updateCart(item.id, 0)"
						>
							<DeleteIcon />
						</button>
					</div>
				</div>
			</li>
		</TransitionGroup>
		<template #action>
			<div class="product-detail__action flex-center">
				<div class="cart__total flex-center">
					<span class="product-detail__label">Grand total</span>
					<span class="product-detail__label cart__total-price">
						{{ cartTotal }} {{ currency }}
					</span>
				</div>
				<button
					class="btn btn-primary product-detail__btn-add-to-cart"
					@click="checkout"
				>
					CHECKOUT
				</button>
				<button
					class="btn btn-text product-detail__btn-add-to-cart"
					@click="continueShopping"
				>
					CONTINUE SHOPPING
				</button>
			</div>
		</template>
	</BottomSheet>
</template>

<script setup>
import BottomSheet from "../shared/BottomSheet.vue";
import DeleteIcon from "../shared/DeleteIcon.vue";
import { computed } from "vue";
import { useCartIntegration } from "@/vue/composables/useCartIntegration";
import { useToast } from "~/vue/composables/useToast";
import { TRACK_SHOPPING } from "~/configs/track";

const {
	trackShopping,
	openCart,
	cart,
	updateItemInCart,
	loading,
	goCheckout,
	openProductDetail,
	openProductList,
	currency,
} = useCartIntegration();
const { toast } = useToast();

const cartTotal = computed(() => {
	return parseFloat(
		cart.value
			.reduce((acc, item) => item.price * item.quantity + acc, 0)
			.toFixed(2)
	).toLocaleString("en-US");
});

async function updateCart(variantId, quantity, isDecrease = false) {
	const { isSuccess } = await updateItemInCart(variantId, quantity, isDecrease);
	if (isSuccess) {
		if (quantity === 0) toast.success("Item deleted successfully!");
		else toast.success("Cart updated successfully!");
	} else {
		if (quantity === 0) toast.error("Error on deleting item!");
		else toast.error("Error on updating cart!");
	}
}

async function checkout() {
	await trackShopping(TRACK_SHOPPING.CHECKOUT);
	goCheckout();
}

function continueShopping() {
	openCart.value = false;
	if (!openProductDetail.value && !openProductList.value) {
		openProductList.value = true;
	}
}
</script>
